export const arrayEquals = (a, b) => {
  return (
    // Array.isArray(a) &&
    // Array.isArray(b) &&
    // a.length === b.length &&
    // a.every((val, index) => val?.toLowerCase() === b[index]?.toLowerCase())
    JSON.stringify(a)?.toLowerCase() === JSON.stringify(b)?.toLowerCase()
  );
};
